// extracted by mini-css-extract-plugin
var _1 = "MessagesTableBodyRow_grayColor__3rdvB";
var _2 = "MessagesTableBodyRow_greenColor__w+yYe";
var _3 = "MessagesTableBodyRow_sentToCell__V-z8D";
export { _1 as "grayColor", _2 as "greenColor", _3 as "sentToCell" }
